import { useRootStore } from "Store/RootStore";

export const useFlighting = (teams: string[]) => {
    const my = useRootStore("MyStore");

    return teams.some((team) => my.flighting.includes(team.toLowerCase()));
};
